import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";
import mainlogo from "../../assets/img/logo.png";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { register } from "../../hooks/api/useAuth";
import { loginRedux } from "../../features/userSlice";
import useWindowSize from "../../hooks/useWindowSize";
import { tailChase } from "ldrs";
import { FcGoogle } from "react-icons/fc";
import { BsApple } from "react-icons/bs";
import { ImFacebook } from "react-icons/im";
import { toast } from "sonner";
import {  SignUpButton, useAuth, useUser } from "@clerk/clerk-react";
import { login, verifyClerkUser } from "../../hooks/api/useAuth";
import { useDispatch } from "react-redux";
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineArrowLeft } from "react-icons/ai";


tailChase.register();

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [contact, setContact] = useState("");
  const size = useWindowSize();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sessionId } = useAuth();
  const { user } = useUser();
  const {
    data,
    isSuccess: registerSuccess,
    error,
    isPending,
    mutate: registerFn,
  } = useMutation({
    mutationFn: register,
  });
  const {
    data:userData,
    isSuccess: verifySuccess,
    error: verifyError,
    isPending: isVerifying,
    mutate: verifyUser,
  } = useMutation({
    mutationFn: verifyClerkUser,
  });

  const [showPass, setShowPass] = useState({
    password: "",
    confirmPassword: "",
    showPasssWord: false,
  });

  const togglePasswordVisibility = (field) => {
    setShowPass((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    registerFn({ email, password, name, dob, contact, gender });
  };
  useEffect(() => {
    const handleRegister = async () => {
      try {
        // const token = await getToken();
        if (!user) {
          return;
        }
        if (sessionId) {
          verifyUser(sessionId);
        }
      } catch (error) {
        toast.error("Failed to authenticate user, please try again");
      }
    };

    handleRegister();
  }, [navigate, sessionId, user]);

  useEffect(() => {
    if (registerSuccess) {
      // After successful registration, dispatch the action
      toast.success("Registered successfully, please login.");
      navigate("/");
    }
    if (verifySuccess){
      // auto nav
      toast.success("Logged in successfully");

      dispatch(
        loginRedux({
          email: userData.email,
          loggedIn: true,
        })
      );
      navigate("/");
    }
    
  }, [registerSuccess, verifySuccess]);

  return (
    <div className="dark:bg-black bg-white flex items-center justify-center h-screen overflow-hidden">
      <div className="mb-[10px] py-5 h-full w-full flex items-center justify-center max-sm:overflow-y-auto max-sm:overflow-x-hidden">
        <div className="flex items-center w-full  justify-center">
          <div className=" mr-[150px] font-bold text-[#3a3856] font-sans  hidden md:block  ml-[20px] ">
            <div className="flex  h-full ">
              <Logo />
            </div>
            <div className="mt-[150px]">
              <div className="start hidden md:block welcomeScreenTextShadow">
                <h1 className="text-[#2A71E8] font-sans text-[60px]  ">Lets</h1>
                <h1 className="flex space-x-2  text-[#2A71E8]  font-sans text-[70px]">
                  Get<span className="ml-3 text-[#be2117]"> Started...</span>
                </h1>
              </div>
            </div>
            <button className="bg-gradient-to-b from-[#BE2117] to-[#053676] rounded-[20px] p-4  px-11 text-white  w-[240px]">
              TRANSLATE
            </button>
          </div>
          <div className=" sm:ml-[5px] mr-9 sm:mr-0 max-sm:mt-[30rem]">
            <div className="sm:shadow-xl   dark:bg-black  sm:space-y-2 sm:rounded-[20px] px-5 sm:bg-[#f4f4f4]   sm:ml-4 sm:mr-4 max-sm:overflow-hidden  w-[400px]">
              <div className="pb-2 flex items-center ml-4  space-x-20 ">
<Link to="/">
                  <AiOutlineArrowLeft className="w-[40px] h-[40px] font-bold ml-3 sm:hidden text-black mt-[5px]" />
                </Link>
                <img
                  src="https://uibfs.s3.eu-north-1.amazonaws.com/logo.png"
                  alt="log"
                  className="mb-4  w-20 h-20  sm:hidden"
                />
              </div>
              <h2 className="font-bold text-[20px] font-sans text-center w-[100%] dark:text-white">
                Create Account
              </h2>
             
             
          
              <form className=" sm:mr-[40px] sm:space-y-3 space-y-8  ml-5 items-center  overflow-auto">
              <div className="flex space-x-10 justify-center cursor-pointer mt-8"> 
              <SignUpButton navigate={(to) => navigate('/')}>
              <div className="flex cursor-pointer space-x-4 justify-center cursor-pointer m-[-5px]">
                  <div class="rounded-full h-10 w-10  py-1 ">
                    <FcGoogle className="w-7 h-7" />
                  </div>
                  <div class="rounded-full  w-10 h-10  bg-[#3C5A99] flex items-center justify-center  ">
                    <ImFacebook color="white" className="w-7 h-7 " />
                  </div>
                  <div className="rounded-full h-10 w-10 bg-[#999999] flex items-center justify-center">
                    <BsApple color="white" className="w-7 h-17" />
                  </div>
                </div>
                </SignUpButton>
              </div>
              <div className="flex items-center justify-center mt-8">
                <div className="border-t border-black w-[130px]"></div>
                <span className="px-2 text-sm text-black font-bold dark:text-white ">
                  OR
                </span>
                <div className="border-t border-black w-[130px]"></div>
               </div>
                <div className="sm:mt-2">
                  <label className="font-bold text-lg font-sans text-[20px] dark:text-white">
                    {" "}
                    Name{" "}
                  </label>

                  <div className="border  border-[#8a8a8a]  sm:w-[300px]  p-2 rounded-[20px] flex w-[350px] items-center px-2  ">
                    <input
                      className="bg-transparent rounded-full p-2 sm:h-[30px] h-[50px] w-full focus:outline-none dark:text-white"
                      type="text"
                      placeholder="Surname"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>
            
               
                <div className="sm:mt-2">
                  <label className="font-bold text-lg font-sans text-[20px] dark:text-white">
                    Date of Birth
                  </label>

                  <div className="border border-[#8a8a8a] sm:w-[300px] p-2 rounded-[20px] flex w-[350px] items-center px-2">
                    <input
                      className="bg-transparent rounded-full p-2 sm:h-[30px] h-[50px] w-full focus:outline-none dark:text-white"
                      type="date"
                      value={dob} // 'dob' should be a state variable
                      onChange={(e) => setDob(e.target.value)} // 'setDob' should update the state
                    />
                  </div>
                </div>
                <div className="">
                  <label className="font-bold  text-lg font-sans text-[20px]dark:text-white">
                    {" "}
                    Email{" "}
                  </label>
                  <div className="border  border-[#8a8a8a] p-2 rounded-[20px]  sm:w-[300px]   w-[350px] flex items-center px-2  ">
                    <input
                      className="bg-transparent rounded-md p-2 w-full sm:h-[30px] h-[50px] focus:outline-none dark:text-white text-black "
                      type="text"
                      placeholder=" Enter Email "
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="sm:mt-2">
                  <label className="font-bold text-lg font-sans text-[20px] dark:text-white">
                    Gender
                  </label>
                  <div className="border border-[#8a8a8a] text-[13px] sm:w-[300px] p-2 rounded-[20px] flex w-[350px] items-center px-2">
                    <select
                      className="bg-transparent rounded-full p-2 sm:h-[30px] h-[50px] w-full focus:outline-none dark:text-white"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="" disabled>
                        Select Gender
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                      <option value="Prefer not to say">Prefer not to say</option>
                    </select>
                  </div>
                </div>
                <div className="">
                  <label className="font-bold  text-lg font-sans text-[20px]dark:text-white">
                    {" "}
                    Contact{" "}
                  </label>
                  <div className="border  border-[#8a8a8a] p-2 rounded-[20px]  sm:w-[300px]   w-[350px] flex items-center px-2  ">
                    <input
                      className="bg-transparent rounded-md p-2 w-full sm:h-[30px] h-[50px] focus:outline-none dark:text-white text-black "
                      type="text"
                      placeholder="Enter Contact "
                      value={contact}
                      onChange={(e) => setContact(e.target.value)}
                    />
                  </div>
                </div>
                <div className="">
                  <label className="font-bold  text-[20px] font-sans dark:text-white">
                    {" "}
                    Password{" "}
                  </label>
                  <div className="border p-2 rounded-[20px] sm:w-[300px]  w-[350px] border-[#8a8a8a] flex items-center px-2  ">
                    <input
                      className="bg-transparent rounded-full sm:h-[30px] h-[50px] p-2 w-full focus:outline-none dark:text-white text-black"
                      type={showPass.password ? "text" : "password"}
                      placeholder=" Enter Password "
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
{showPass.password ? (
                      <AiOutlineEyeInvisible
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    ) : (
                      <AiOutlineEye
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    )}
                  </div>
                </div>

                <div className="">
                  <label className="font-bold  text-lg dark:text-white">
                    {" "}
                    Confirm Password{" "}
                  </label>
                  <div className="border p-2 rounded-[20px] sm:w-[300px]  w-[350px] border-[#8a8a8a] flex items-center px-2  ">
                    <input
                      className="bg-transparent rounded-full p-2  h-[50px] sm:h-[30px] w-full focus:outline-none dark:text-white"
                      type={showPass.confirmPassword ? "text" : "password"}
                      placeholder="Enter Password "
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
{showPass.confirmPassword ? (
                      <AiOutlineEyeInvisible
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("confirmPassword")}
                      />
                    ) : (
                      <AiOutlineEye
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => togglePasswordVisibility("confirmPassword")}
                      />
                    )}
                  </div>
                </div>
                {confirmPassword !== password && (
                  <div className="text-red-500 text-center text-sm mb-2">
                    Passwords do not match.
                  </div>
                )}
                {error && (
                  <div className="text-red-500 text-center text-sm mb-2">
                    Failed to register user. Please try again.
                  </div>
                )}
                <Link to="/">
                  <button
                    className="bg-[#2A71E8] sm:w-[300px]  h-[50px] w-[350px] py-3  sm:mt-2 mb-2  mt-11 text-white font-bold  px-4   border  rounded-[20px] focus:outline-none focus:shadow-outline block "
                    type="button"
                    disabled={isPending}
                    onClick={handleSubmit}
                  >
                    {(isPending | isVerifying )? (
                      <l-tail-chase
                        size="25"
                        speed="1.75"
                        color="black"
                      ></l-tail-chase>
                    ) : (
                      "Create Account"
                    )}
                  </button>
                </Link>
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
